import { useMemo } from "react";
import type { NotificationFilters } from "@/lib/notification.api";
import { useNotifications } from "@/hooks/queries/useNotifications";
import { useMarkAllNotificationsReadMutation } from "@/hooks/mutations/useNotificationMutations";
import { PAGE_SIZE } from "../notification.constants";

export function useNotificationInboxData(filters: NotificationFilters) {
  const { data, isLoading, isFetching } = useNotifications(filters);
  const markAllReadMutation = useMarkAllNotificationsReadMutation();

  const notifications = data?.data ?? [];
  const total = data?.total ?? 0;
  const unread = data?.unread ?? 0;
  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE));

  const stats = useMemo(() => {
    const critical = notifications.filter((item) => item.severity === "danger").length;
    const warnings = notifications.filter((item) => item.severity === "warning").length;
    return { currentPage: notifications.length, unread, critical, warnings };
  }, [notifications, unread]);

  return {
    notifications,
    total,
    unread,
    pageCount,
    stats,
    isLoading,
    isFetching,
    markAllReadMutation,
  };
}
